import React from 'react';
import { graphql } from 'gatsby';
import { parseAsContent } from 'utils/parser';

import WrapPbSection from 'components/common/WrapPbSection';
import WrapSection from 'components/common/WrapSection';

import RichText from 'components/common/RichText';

import { RichTextInnerStyled } from './PageBuilderRichTextStyled';

export default function PageBuilderRichText({ data }) {
  const {
    richtextContent,
    richtextContentMore,
    richtextContentMoreLabel,
    richtextGoldenBackground
  } = data;

  console.log('content', richtextContent);

  return (
    <WrapPbSection goldenBackground={richtextGoldenBackground}>
      <WrapSection>
        <RichTextInnerStyled>
          <RichText
            moreText={parseAsContent(richtextContentMore?.content)}
            moreTextLabel={richtextContentMoreLabel}
            goldenBackground={richtextGoldenBackground}
          >
            {parseAsContent(richtextContent?.content)}
          </RichText>
        </RichTextInnerStyled>
      </WrapSection>
    </WrapPbSection>
  );
}

export const query = graphql`
  fragment PageBuilderRichTextQuery on Craft_PageBuilderNeoRichText {
    id
    richtextContent {
      content
    }
    richtextContentMoreLabel
    richtextContentMore {
      content
    }
    richtextGoldenBackground
  }
`;
